import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Cloud, Smartphone, Puzzle, Zap, Shield, TrendingUp } from 'lucide-react';

const ProofSection = () => {
  const advantages = [
    {
      icon: <Cloud className="h-8 w-8 text-blue-600" />,
      title: "Alles drin, was du brauchst",
      description: "Alle wichtigen Funktionen sind bereits enthalten. Wenn du mehr brauchst, kannst du jederzeit erweitern - ohne komplizierte Installation."
    },
    {
      icon: <Smartphone className="h-8 w-8 text-green-600" />,
      title: "Überall verfügbar",
      description: "Arbeite von überall - im Büro, zu Hause oder unterwegs. Einfach Browser öffnen oder die App nutzen. Deine Daten sind immer dabei."
    },
    {
      icon: <Puzzle className="h-8 w-8 text-purple-600" />,
      title: "Funktioniert mit Office",
      description: "Nutzt du schon Outlook und Excel? Perfekt! Business Central arbeitet nahtlos mit deinen gewohnten Microsoft-Programmen zusammen."
    },
    {
      icon: <Zap className="h-8 w-8 text-orange-600" />,
      title: "Sofort startklar",
      description: "Keine Server kaufen, keine IT-Abteilung nötig. Du meldest dich an und kannst direkt loslegen. Einfacher geht's nicht."
    },
    {
      icon: <Shield className="h-8 w-8 text-red-600" />,
      title: "Sicher wie Fort Knox",
      description: "Deine Daten sind in deutschen Microsoft-Rechenzentren gespeichert. Höchste Sicherheitsstandards und 99,9% Verfügbarkeit garantiert."
    },
    {
      icon: <TrendingUp className="h-8 w-8 text-teal-600" />,
      title: "Wächst mit dir mit",
      description: "Startest du klein? Kein Problem. Du kannst mit einem Nutzer beginnen und jederzeit weitere Lizenzen dazubuchen - ganz flexibel."
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold mb-4">
            Warum Business Central die richtige Wahl ist
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Als Geschäftsführer willst du eine Lösung, die funktioniert - ohne Kopfschmerzen und ohne versteckte Kosten. 
            Hier sind die wichtigsten Vorteile auf einen Blick:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {advantages.map((advantage, index) => (
            <Card key={index} className="border-0 shadow-md hover:shadow-lg transition-all duration-300 h-full">
              <CardContent className="p-6 flex flex-col h-full">
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0">
                    {advantage.icon}
                  </div>
                  <div className="flex-grow">
                    <h3 className="text-lg font-bold mb-3 text-gray-900">
                      {advantage.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {advantage.description}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center mt-12">
          <div className="bg-blue-50 rounded-lg p-8 max-w-2xl mx-auto">
            <h3 className="text-xl font-bold mb-4 text-blue-900">
              Neugierig geworden?
            </h3>
            <p className="text-blue-800 mb-4">
              Gerne zeigen wir dir eine Produktdemo und besprechen ob Business Central das passende System für dich ist. Kostenlos, ohne Verpflichtung.
            </p>
            <a 
              href="#contact" 
              className="inline-block bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors duration-200"
            >
              Produktdemo anfragen
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProofSection; 